module.exports = __webpack_public_path__ + "res/cannon_craze.68bf2d7ca517eeeea5ac2db3f9ec76b7.webp";